import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Refresh } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { StyledButton } from 'app/components';
import { Colors } from 'app/constants/color';
import { DarkmodeColors } from 'app/constants/color';

const withConnectionStatus = WrappedComponent => {
  const EnhancedComponent = () => {
    const { darkmode } = useSelector(state => state.dark);
    const [isConnected, setIsConnected] = useState(navigator.onLine);
    const { t } = useTranslation('translation', { keyPrefix: 'no_internet' });

    useEffect(() => {
      const handleConnectionChange = () => {
        setIsConnected(navigator.onLine);
      };

      window.addEventListener('online', handleConnectionChange);
      window.addEventListener('offline', handleConnectionChange);

      return () => {
        window.removeEventListener('online', handleConnectionChange);
        window.removeEventListener('offline', handleConnectionChange);
      };
    }, []);

    return isConnected ? (
      <WrappedComponent />
    ) : (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: darkmode ? DarkmodeColors.appBar : '#f1f1f1',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            src={
              darkmode ? './assets/images/no-wifi-dark.svg' : './assets/images/no-wifi-light.svg'
            }
            alt=''
          />
          <Typography
            variant='h4'
            noWrap
            component='div'
            sx={{
              color: Colors.primary,
              fontFamily: 'Roboto, sans-serif',
              fontSize: '48px',
              lineHeight: '48px',
              fontWeight: '500',
            }}
            gutterBottom
          >
            {t('heading')}
          </Typography>
          <Typography
            variant='h5'
            noWrap
            component='div'
            color={darkmode ? 'white' : 'black'}
            style={{ marginBottom: '1rem' }}
          >
            {t('description')}
          </Typography>
          <StyledButton
            onClick={() => window.location.reload(false)}
            name='Save'
            startIcon={<Refresh />}
            sx={{ marginTop: '30px', marginRight: '10px' }}
          >
            {t('refresh')}
          </StyledButton>
        </div>
      </div>
    );
  };

  return EnhancedComponent;
};

export default withConnectionStatus;
